module.exports = __webpack_public_path__ + "static/img/20g.22fd8b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20g.jpg
// module id = m60M
// module chunks = 0